// extracted by mini-css-extract-plugin
module.exports = {"icon":"Icon-6505ecac3a292bc6eb206ec33aac0aca"};